export default "__VITE_ASSET__C0VGJH1L__"